export default __webpack_public_path__ + "static/media/excercise-icon.1f3011a3.svg";